import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as fileSaver from 'file-saver';
import { CoreService } from './core.service';
import { ToastService } from '../toast/toast.service';
import { FileModel } from '../models/global/class.global';
import { b64EncodeUnicode } from '../utilities';
import { ConfigKey } from '../models';


@Injectable({ providedIn: 'root' })

export class FilesManagerService {
  constructor(
    private http: HttpClient,
    private core: CoreService,
    private toasts: ToastService
  ) { }

  // ----------------- DOWNLOAD FILE -----------------

  /**
   * Téléchargement d'un fichier en production
   **/
  downloadFile(fileModel: FileModel, openPdf: boolean = false): void {
    this.download(fileModel, fileModel.Name, `${this.core.AppParams.apiUrl}api/Download`, openPdf);
  }

  /**
   * Téléchargement d'un fichier dans les média (API Stream)
   **/
  downloadMedia(fileModel: FileModel, openPdf: boolean = true): void {
    const data: any = { QueovalOriginalName: fileModel.Name, FilePath: fileModel.FullPath, DownloadType: fileModel.DownloadMode };
    this.download(data, fileModel.Name, `${this.core.getConfigKey(ConfigKey.STREAM_HTTP)}api/StreamDownload`, openPdf);
  }

  public download(fileModel: FileModel | any, fileName: string, urlApi: string, openPdf: boolean): void {
    //const data: FileModel = fileModel;
    //const config: any = {
    //  responseType: 'arraybuffer' as 'arraybuffer'
    //};

    //return this.http.post(`${this.core.AppParams.apiUrl}api/Download`, data, config);

    this.core.showSplash(true);

    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };

    this.http.post(urlApi, fileModel, config).subscribe((response: any) => {
      if (response) {
        // code modifié (avec response -> arraybuffer) ---------------------------------------------------------
        let extension: string = (fileModel.Extension && fileModel.Extension !== '') ? fileModel.Extension : fileName.split('.').pop() as string;
        if (!extension) {
          this.toasts.showAlertToast(`format de fichier non géré.`);
          this.core.showSplash(false);
          return;
        }
        extension.replace('.', '');
        let fileType: string = '';
        switch (extension) {
          case 'rar': fileType = 'application/rar'; break;
          case 'zip': fileType = 'application/zip'; break;
          case 'pdf': fileType = 'application/pdf'; break;
          case 'jpg': fileType = 'image/jpg'; break;
          case 'jpeg': fileType = 'image/jpeg'; break;
          case 'png': fileType = 'image/png'; break;
          case 'gif': fileType = 'image/gif'; break;
          case 'xml': fileType = 'application/xml'; break;
          case 'txt': fileType = 'text/plain'; break;
          case 'doc': fileType = 'application/vnd.ms-word'; break;
          case 'docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
          case 'xls': fileType = 'application/vnd.ms-excel'; break;
          case 'xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
          case 'bmp': fileType = 'image/bmp'; break;
          case 'wav': fileType = 'audio/wav'; break;
          case 'ppt': fileType = 'application/vnd.ms-powerpoint'; break;
          case 'pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
          case 'dwg': fileType = 'image/vnd.dwg'; break;
        }
        const blob: Blob = new Blob([(response)], {
          type: fileType,
        });

        const openWindow = fileType == 'application/pdf' && openPdf;

        if (blob.size > 0) {
          let displayFileName: string = fileModel.DisplayName ? fileModel.DisplayName : fileName;
          if (!displayFileName.endsWith(`.${extension}`))
            displayFileName = `${displayFileName}.${extension}`;

          if (window.navigator && !openWindow) {
            fileSaver.saveAs(blob, displayFileName);
          } else {
            // Pour le PDF on l'ouvre dans une nouvelle fenêtre
            // tslint:disable-next-line:typedef
            const objectUrl = URL.createObjectURL(blob);
            window.open(objectUrl);
            // Ouverture dans une iframe avec pour titre le nom du fichier
            //var win = window.open();
            //if (win) {
              //win.document.write('<iframe name="' + displayFileName + '" src="' + objectUrl + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
              //win.document.title = displayFileName;
            //}
          }          
        }
        this.core.showSplash(false);
      }
      else {
        //Le document n'a pas été trouvé sur le serveur
        this.toasts.showAlertToast(`Le document n'est pas disponible.`);
        this.core.showSplash(false);
      }

      // --------------------------------------------------------------------------------
    });
  }

  // upload
  upload(token: string, fileToUpload: File, fileName: string, mode: string): any {
    const fileNameB64: string = b64EncodeUnicode(fileName);
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer',
      headers: { 'Queoval': token, 'mode': mode, 'fileName': fileNameB64 }
    };
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileNameB64);
    formData.append('name', fileNameB64);
    formData.append('mode', mode);
    formData.append('token', this.core.AppParams.token);
    return this.http.post(`${this.core.AppParams.apiUrl}api/Upload`, formData, config);
  }

}
